import owd from 'owd/owd';

export default class Slide extends owd.Component {
	init() {
		this.bind();
	}
    
    goToSlide(id) {
        const offsetTop = $(id).offset().top - 35;
        $('html, body').animate({
            scrollTop: `${offsetTop}px`
        }, 600, () => {
            //location.hash = id;
        });
    }

	bind() {
        
        this.on('click', '.slide-navigation-link', (e) => {
            e.preventDefault();
            
            const target = $(e.currentTarget);
            const href = target.attr('href');
            
            this.goToSlide(href);
        });
        
//        this.on('domready ajaxload', this.dom.$window, (e) => {
//            if (document.location.hash !== '') {
//              const locationSlide = document.location.hash;
//              this.goToSlide(locationSlide);
//            }
//        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('slide', {
	component: Slide
});
